import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded px-3 py-1 text-[12px] font-semibold",
  {
    variants: {
      variant: {
        primary: "bg-blue-50 text-blue-900",
        success: "bg-green-100 text-green-700",
        muted: "bg-gray-100 text-gray-400",
        info: "bg-blue-50 text-blue-600",
        warning: "bg-orange-50 text-orange-500",
        danger: "bg-red-50 text-red-600",
        outline: "bg-white border border-gray-200 text-gray-700",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  console.log("variant", variant);

  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { badgeVariants };
